import React from 'react'
import { Helmet } from 'react-helmet';
import { useStateContext } from '../../components/contexts/ContextProvider';
import LoadContentSpinner from '../../components/Utils/LoadContentSpinner';
import { Link } from 'react-router-dom';

export default function MainPage() {

    // useEffect(() => {
    //     // Mettre à jour le titre de la page
    //     document.title = "Devenir Organisateur événementiel - Events";
        
    // }, []);

    const { user, loading } = useStateContext();
    const imagePath = process.env.REACT_APP_IMAGE_PATH;

    if (loading) {
        return <LoadContentSpinner />;
    }

    return (
        <div className='bg-white text-base dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200'>
            <Helmet>
                <title>Devenir Organisateur d'Événements | Events - Plateforme de Billetterie Événementielle en Côte d'Ivoire</title>

                <meta
                    name="description"
                    content="Devenez organisateur avec Events ! Publiez, gérez et vendez vos billets facilement. Une plateforme intuitive conçue pour les organisateurs d'événements en Côte d'Ivoire. Maximisez vos ventes dès aujourd’hui."
                />

                <meta
                    name="keywords"
                    content="devenir organisateur d'événements, organiser événements Côte d'Ivoire, création événement événementiel, gestion événements Abidjan, billetterie événementielle Afrique, vendre billets événements, publication événements en ligne, plateforme événementielle CI"
                />

                <meta name="author" content="Events" />

                {/* Open Graph */}
                <meta property="og:title" content="Devenir Organisateur d'Événements | Events - Plateforme de Billetterie Événementielle en Côte d'Ivoire" />
                <meta
                    property="og:description"
                    content="Publiez, gérez et vendez vos événements avec Events. Une plateforme simple et performante dédiée aux organisateurs en Côte d'Ivoire. Rejoignez-nous et atteignez un large public."
                />
                <meta property="og:image" content="https://eventsbilletterie.com/assets/images/stat-dash.png" />
                <meta property="og:url" content="https://eventsbilletterie.com/organisateurs/devenir-organisateur-events" />
                <meta property="og:type" content="website" />

                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Devenir Organisateur d'Événements | Events - Plateforme de Billetterie Événementielle en Côte d'Ivoire" />
                <meta
                    name="twitter:description"
                    content="Publiez, gérez et vendez vos événements avec Events. Une plateforme simple et performante dédiée aux organisateurs en Côte d'Ivoire. Rejoignez-nous et atteignez un large public."
                />
                <meta name="twitter:image" content="https://eventsbilletterie.com/assets/images/stat-dash.png" />
                <meta name="twitter:site" content="@events_billetterie" /> {/* Remplace par ton handle Twitter si applicable */}

                {/* Canonical URL */}
                <link rel="canonical" href="https://eventsbilletterie.com/organisateurs/devenir-organisateur-events" />
            </Helmet>

            <div className="nc-BgGlassmorphism absolute inset-x-0 md:top-10 xl:top-40 min-h-0 pl-20 py-24 flex overflow-hidden z-0" data-nc-id="BgGlassmorphism">
            
                <span className="block bg-[#5bcfc5] w-72 h-72 rounded-full mix-blend-multiply filter blur-3xl opacity-5 lg:w-96 lg:h-96" />
                <span className="block bg-[#04868b] w-72 h-72 -ml-20 mt-40 rounded-full mix-blend-multiply filter blur-3xl opacity-5 lg:w-96 lg:h-96 nc-animation-delay-2000" />
            </div>
            <div className="container px-1 sm:px-4 h-fit mb-24">
                <div className="nc-SectionHero3 relative mt-10 mb-24">
                    <div className="relative z-10 inset-x-0 top-[10%] sm:top-[15%] text-center flex flex-col items-center max-w-4xl mx-auto space-y-4 lg:space-y-3 xl:space-y-5">
                        <h2 className="font-bold text-black text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-5xl">
                        Publiez, vendez et suivez vos billets sans friction avec <span className='underlined'>Events billetterie</span>
                        </h2>
                        {user ? (

                            <a href={"/dashboard/events/registration"} className="!mt-10 relative items-center justify-center text-md font-medium px-6 py-2 lg:px-8 lg:py-2 rounded-lg bg-primary-6000 hover:bg-primary-700 text-neutral-50 focus:outline-none focus:ring-offset-2 dark:focus:ring-offset-0">
                                Commencer à publier
                            </a>
                        ) : (
                            <Link to={"/create-account"} className="!mt-10 relative items-center justify-center text-md font-medium px-6 py-2 lg:px-8 lg:py-2 rounded-lg bg-primary-6000 hover:bg-primary-700 text-neutral-50 focus:outline-none focus:ring-offset-2 dark:focus:ring-offset-0">
                                Créer mon compte organisateur
                            </Link>
                        )}
                    </div>
                </div>
                

            <div className="relative grid grid-cols-1 gap-10 p-4 lg:grid-cols-2 lg:gap-16 !mt-10 !mb-10">
                <div
                    className="flex-grow w-full"
                    style={{ display: "flex", justifyContent: "center" }}
                >
                    <img
                        className="max-w-full sm:!max-w-[30rem] h-auto shadow-md rounded-xl"
                        alt=""
                        loading="lazy"
                        decoding="async"
                        data-nimg={1}
                        style={{ color: "transparent",  }}
                        src={`${imagePath}images/stat-dash.png`}
                    />
                </div>
                <div className="flex-shrink-0 lg:mt-0 lg:pl-8 sm:mx-8">
                    <h2 className="font-semibold text-4xl mt-3 mb-4">
                        Pilotez votre événement de A à Z avec <span className=''>une seule plateforme</span>
                    </h2>
                    <span className="text-gray-700 dark:text-gray-300">
                        Nous vous accompagnons à structurer chaque étape de votre événement : création de l&apos;événement, vente de billets, suivi des participants, contrôle d&apos;accès et analyse des performances.
                        Résultat : moins d&apos;allers-retours techniques, moins de tracasseries, une meilleure visibilité sur vos revenus et une expérience participant plus fluide.
                    </span>
                </div>
                
            </div>

            <div className="mt-24">
                <div className="nc-SectionHowItWork" style={{marginBottom: '3rem'}}>
                    <div className="nc-Section-Heading relative flex flex-col sm:flex-row sm:items-center justify-between mb-12 lg:mb-16 text-neutral-900 dark:text-neutral-50" style={{textAlign: 'center', flexDirection: 'column', alignItems: 'center'}}>
                        <div className="text-center w-full max-w-2xl mx-auto">
                            <h2 className="text-3xl md:text-4xl font-semibold">Pourquoi les organisateurs choisissent Events billetterie ?</h2>
                        </div>
                        <span className="mt-2 px-2 md:mt-3 font-normal block text-base sm:text-lg text-gray-700 dark:text-neutral-400 w79">
                            Une solution conçue pour accélérer vos ventes, simplifier l&apos;opérationnel et sécuriser la gestion de vos événements.
                        </span>
                    </div>
                </div>

                <main className="container relative z-10 mt-11 flex flex-col lg:flex-row ">
                    <div className="block flex-grow mb-2 lg:mb-0">
                        <div className="lg:sticky lg:top-2">
                            <div className="w-full items-center space-y-6 sm:space-y-7 px-0 sm:p-6 xl:p-8">
                                <img
                                    className="inset-0 w-full h-full object-cover"
                                    srcSet={`${imagePath}images/Events.avif`}
                                    alt="illustration"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pl-10 flex-shrink-0">
                        <div className="prose">
                            <ol>
                                <li>
                                    <h2 className="text-xl font-semibold">Mise en ligne flexible et professionnelle</h2>
                                    <span className="block mt-2 mb-10 text-gray-700 dark:text-gray-400">
                                        Créez et personnalisez vos événements selon vos besoins : concerts, conférences, festivals, spectacles ou soirées privées.
                                        En quelques étapes, votre page est prête, lisible et optimisée pour la conversion.
                                        {user ? ( 
                                            <a href={"/dashboard/events/registration"} className="font-medium !text-blue-600">
                                                &nbsp;&nbsp;Créer ma billetterie maintenant
                                            </a>
                                        ) : (
                                            <Link to={"/login"} className="font-medium !text-blue-600">
                                                &nbsp;&nbsp;Créer ma billetterie maintenant
                                            </Link>
                                        )}
                                    </span>
                                </li>

                                <li>
                                    <h2 className="text-xl font-semibold">Publication simple et rapide</h2>
                                    <span className="block mt-2 mb-10 text-gray-700 dark:text-gray-400">
                                        Votre équipe peut publier un événement en quelques minutes, sans dépendre d&apos;un prestataire technique.
                                        Vous gagnez du temps et vous gardez le contrôle sur vos contenus.
                                    </span>
                                </li>

                                <li>
                                    <h2 className="text-xl font-semibold">Contrôle des ventes et date de clôture personnalisée</h2>
                                    <span className="block mt-2 mb-10 text-gray-700 dark:text-gray-400">
                                        Choisissez vous-même la date de fin de vente de vos billets selon votre stratégie.
                                        Vous pouvez clôturer en avance pour mieux organiser votre logistique ou rester ouvert jusqu&apos;à la dernière minute.
                                    </span>
                                    <span className="listingSection__wrap li-style block mt-2 mb-5 text-gray-700 dark:text-gray-400">
                                        Vous décidez quand arrêter les ventes et {''}
                                        {user ? (
                                            <a href={"/dashboard"} className="font-medium !text-blue-600"> 
                                            suivre vos versements.
                                            </a>
                                        ) : (
                                            <Link to={"/login"} className="font-medium !text-blue-600"> 
                                                suivre vos versements.
                                            </Link>
                                        )} {''}
                                        La gestion de votre trésorerie devient plus prévisible et plus sereine.
                                    </span>
                                    <span className="listingSection__wrap li-style block mt-2 mb-10 text-gray-700 dark:text-gray-400">
                                        Avec cette flexibilité, vous adaptez votre plan de vente à chaque événement et à chaque audience. <br /><br />
                                        {user ? (

                                            <a href={"/dashboard"} className="font-medium !text-blue-600">Rejoignez la communauté des organisateurs d'événements</a> 
                                        ) : (
                                            <Link to={"/login"} className="font-medium !text-blue-600">
                                                Rejoignez la communauté des organisateurs d'événements
                                                </Link> 
                                        )} {''}
                                        qui profitent déjà de cette flexibilité sur <b>Events billetterie</b> et optimisez vos ventes dès aujourd'hui!
                                    </span>
                                </li>

                                <li>
                                    <h2 className="text-xl font-semibold">Gestion intégrée des billets</h2>
                                    <span className="block mt-2 mb-10 text-gray-700 dark:text-gray-400">
                                        Suivez vos ventes en temps réel, surveillez les performances et anticipez les pics d&apos;affluence pour mieux piloter l&apos;événement.
                                    </span>
                                </li>

                                <li>
                                    <h2 className="text-xl font-semibold">Paiements sécurisés et traçables</h2>
                                    <span className="block mt-2 mb-10 text-gray-700 dark:text-gray-400">
                                    Proposez des paiements fiables à vos participants et bénéficiez d&apos;un suivi clair des transactions et des versements.
                                    </span>
                                </li>

                                <li>
                                    <h2 className="text-xl font-semibold">Contrôle d&apos;accès rapide par QR code</h2>
                                    <span className="block mt-2 mb-10 text-gray-700 dark:text-gray-400">
                                        Scannez les billets en quelques secondes à l&apos;entrée et réduisez les files d&apos;attente.
                                        L&apos;expérience participant est plus fluide et la sécurité des accès est renforcée.
                                    </span>
                                </li>

                                <li>
                                    <h2 className="text-xl font-semibold">Support dédié</h2>
                                    <span className="block mt-2 mb-10 text-gray-700 dark:text-gray-400">
                                        Notre équipe vous accompagne avant, pendant et après la mise en ligne de votre événement pour sécuriser vos opérations.
                                    </span>
                                </li>
                            </ol>
                            <span className="listingSection__wrap block mt-2 mb-10 text-gray-700 dark:text-gray-400">
                                En choisissant <b>Events billetterie</b>, vous équipez votre organisation d&apos;un véritable outil de croissance événementielle : plus de clarté, plus de contrôle et plus d&apos;impact.
                                <br />
                                <a href={"/Events-usedFolder/FAQs-events?tab=organizer"} className="font-medium !text-blue-600">
                                    Centre d'aide organisateurs
                                </a>
                            </span>
                        </div>
                    </div>
                </main>

            </div>
            <div className="max-w-5xl container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="bg-gradient-to-br from-[#5bcfc5] to-[#3da8a0] rounded-3xl sm:p-12 p-5 shadow-2xl">

                    <div className="relative flex flex-col items-center sm:max-w-4xl mx-auto">
                        <div className="text-center mt-auto px-4">
                            <h3 className="text-3xl md:text-5xl text-gray-50 font-bold">
                            Réduisez vos coûts opérationnels grâce à
                            une plateforme <span className='underlined'>tout-en-un</span>.
                            </h3>
                            <span className="block text-md mt-5 text-gray-100 dark:text-gray-300">
                            Rejoignez les organisateurs qui centralisent déjà leur billetterie, leur contrôle d&apos;accès et leur suivi de performances sur Events.
                            </span>
                        </div>
                    </div>
                    <div className="flex mt-2 justify-center items-center">
                        {user ? (
                            <a href='/dashboard' className="nc-Button relative h-auto inline-flex items-center justify-center rounded-lg transition-colors text-sm sm:text-sm font-medium px-4 py-2 sm:px-4 ttnc-ButtonPrimary bg-primary-6000 hover:bg-primary-700 text-white mt-6 sm:mt-6">
                            Commencer maintenant
                            </a>
                        ) : (
                            <Link to='/login' className="nc-Button relative h-auto inline-flex items-center justify-center rounded-lg transition-colors text-sm sm:text-sm font-medium px-4 py-2 sm:px-4 ttnc-ButtonPrimary bg-primary-6000 hover:bg-primary-700 text-white mt-6 sm:mt-6">
                            Commencer maintenant
                            </Link>
                        )}
                    </div>
                </div>
            </div>
            </div>

        </div>
    )
}
